import { useLayoutEffect, useEffect } from 'react'

// useIsomorphicLayoutEffect let user to decide which function they want to use (window.scroll or target.getBoundingClientRect())
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect
